import { arrayMove } from '@dnd-kit/sortable'

const useContentBlocks = ({ blocks, onChangeBlocks }) => {
  const handleSortEnd = event => {
    const { active, over } = event
    if (!over || active.id === over.id) return

    const oldIndex = blocks.findIndex(block => block.identifier === active.id)
    const newIndex = blocks.findIndex(block => block.identifier === over.id)

    onChangeBlocks(arrayMove(blocks, oldIndex, newIndex).map((block, index) => ({ ...block, position: index })))
  }

  const handleSortStart = () => {
    document.body.style.cursor = 'grabbing'
  }

  const handleToggle = identifier => {
    const updatedBlocks = blocks.map(block =>
      block.identifier === identifier ? { ...block, enabled: !block.enabled } : block
    )
    onChangeBlocks(updatedBlocks)
  }

  return { handleSortEnd, handleSortStart, handleToggle }
}

export default useContentBlocks
